/*
 * @Description: 
 * @Author: kangkang
 * @Date: 2022-06-26 22:24:06
 * @LastEditTime: 2023-04-11 20:28:55
 * @LastEditors: kangkang
 * @Reference: 
 */
import Vue from "vue";
import 'vant/lib/index.css';

// toast
import { Toast } from 'vant';

Vue.use(Toast);
// Loading
import { Loading } from 'vant';

Vue.use(Loading);

// Popup 弹出层
import { Popup } from 'vant';

Vue.use(Popup);

// 轮播
import { Swipe, SwipeItem } from 'vant';

// Switch 开关
Vue.use(Swipe);
Vue.use(SwipeItem);

import { Cell, CellGroup } from 'vant';

import { Switch } from 'vant';

Vue.use(Switch);

// Uploader 文件上传
import { Uploader } from 'vant';

Vue.use(Uploader);

// DatetimePicker 时间选择
import { DatetimePicker } from 'vant';

Vue.use(DatetimePicker);

// Cell 单元格
Vue.use(Cell);
Vue.use(CellGroup)

// Form 表单
import { Form } from 'vant';
import { Field } from 'vant'

Vue.use(Form);
Vue.use(Field);

// Icon 图标
import { Icon } from 'vant';

Vue.use(Icon);

// Layout 布局
import { Col, Row } from 'vant';

Vue.use(Col);
Vue.use(Row);

import { Overlay } from 'vant';

// Button 按钮
import { Button } from 'vant';

Vue.use(Button);

// Overlay 遮罩层
Vue.use(Overlay);
// 键盘
import { PasswordInput, NumberKeyboard } from 'vant';
Vue.use(PasswordInput).use(NumberKeyboard);

Vue.prototype.$dialog = {
    toast: Toast
};